export const API_URL = process.env.REACT_APP_API_URL;
export const S3_URL = process.env.REACT_APP_S3_URL;
export const MAP_KEY = process.env.REACT_APP_MAP_KEY;
export const RZP_KEY = process.env.REACT_APP_RZP_KEY;
export const ABLY_KEY = process.env.REACT_APP_ABLY_KEY;
export const UI_PATH = process.env.REACT_APP_UI_PATH;
